import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedChassisFilters = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('chassisFilter'), [searchParameters]);
};

export default useSelectedChassisFilters;
